import { useCallback, useMemo, useEffect, useState } from "react";
import { getCollectionWithQuery } from "db/queries";
import { where } from "firebase/firestore";

export const useFetchActive = (COLLECTION_NAME, converter) => {
  const [data, setData] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loading = useMemo(() => {
    return isLoading || !data.length;
  }, [isLoading, data.length]);

  const fetchData = useCallback(() => {
    getCollectionWithQuery(
      COLLECTION_NAME,
      [where("status", "==", "active")],
      converter
    )
      .then((data) => setData(data))
      .catch((err) => setError(err))
      .finally(() => setLoading(false));
  }, [COLLECTION_NAME, converter]);

  useEffect(() => {
    if (!data.length && !isLoading) {
      setLoading(true);
      fetchData();
    }
  }, []);

  useEffect(() => {
    if (isLoading && data.length) {
      setLoading(false);
    }
  }, [isLoading, data]);

  return { data, loading, error };
};
